// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {QualificationsModuleLayout} from 'app_components/modules/campus/academic/qualifications'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import storeService from 'app_services/storeService'
import QualificationService from 'app_services/campus/academic/qualificationsService'
// @end

// @import types
import {IMyCourse} from 'app_types/campus/academic/myCoursesTypes'
// @end

// @ADD Component types
interface IQualificationsModuleProps {}
interface IQualificationsModuleState {
  status: null | 'loading' | 'error'
  qualificationData: Array<any>
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class QualificationsModule extends Component<IQualificationsModuleProps, IQualificationsModuleState> {

  private qualificationService: QualificationService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IQualificationsModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      qualificationData: [],
    }
    this.qualificationService = new QualificationService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected',this.fetchQualifications)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected',this.fetchQualifications)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchQualifications = async (data: IMyCourse | null) => {

    this.setState({
      status: 'loading',
      qualificationData: [],
    })

    if (data?._id) {
      const dataResponse = await this.qualificationService.fetchQualifications({
        courseID: data?._id,
      })

      if (dataResponse && dataResponse.qualifications) {
        // let count = 0
        const qualifications = dataResponse.qualifications.reduce((accum: Array<any>, element) => {
          accum.push(element)
          // count++
          return accum
        }, [])
        this.setState({qualificationData: qualifications, status: null})
      } else {
        this.setState(({status: null}))
      }
    } else {
      this.setState(({status: null}))
    }
  }

  render() {
    return(
      <QualificationsModuleLayout
        status={this.state.status}
        qualificationData={this.state.qualificationData}
      />
    )
  }
}

export default connect(mapStatesToProps)(QualificationsModule)
